import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SexList } from 'app/shared/models/class/sex-list/sex-list';
import { environment } from 'environments/environment';
import { Observable, observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SexListService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getSexList(): Observable<SexList[]> {
    return this.http.get<SexList[]>(`${environment.apiUrl}/Sex/GetSexList`);
  }

}
